import { GridSortModel } from "@mui/x-data-grid-premium";

/**
 * Drop persisted sort entries whose column no longer exists. localStorage can
 * hold a sortModel referencing a column a later release removed; replaying it
 * would keep an invisible server-side order with no header indicator and no
 * way to clear it.
 *
 * When pruning would empty a non-empty model, returns `fallback` instead
 * (the grid's initial sort), so the user lands on the same visibly-indicated
 * default ordering a fresh user gets rather than the API's silent no-sort
 * fallback. Returns the input array unchanged when nothing is dropped, so
 * memoized references stay stable.
 */
export function pruneSortModelToColumns(
  sortModel: GridSortModel,
  columns: readonly { field: string }[],
  fallback: GridSortModel
): GridSortModel {
  const fields = new Set(columns.map((column) => column.field));
  const kept = sortModel.filter((entry) => fields.has(entry.field));
  if (kept.length === sortModel.length) return sortModel;
  return kept.length > 0 ? kept : fallback;
}
